import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import MUIModal from '@mui/material/Modal';
import { styled } from '@mui/material/styles';
const modalSizeMap = {
    large: 840,
    medium: 720,
    small: 414,
};
export const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
    backgroundColor: theme.palette.cream900.main,
    opacity: '0.38 !important',
}));
export const Modal = styled(MUIModal)(({ theme }) => ({
    position: 'fixed',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .MuiBox-root': {
        [theme.breakpoints.down('sm')]: {
            maxHeight: 592,
        },
    },
}));
export const Container = styled(Box)(({ theme, $width, $height }) => ({
    width: 'calc(100% - 48px)',
    maxWidth: modalSizeMap[$width],
    minHeight: $height === 'large' ? 640 : 254,
    maxHeight: $height === 'large' ? 'calc(100% - 96px)' : 720,
    display: 'flex',
    flexDirection: 'column',
    borderRadius: theme.spacing(8),
    border: `1px solid ${theme.palette.cream100.main}`,
    backgroundColor: theme.palette.white.main,
    zIndex: 1000,
    outline: 0,
    padding: theme.spacing(6),
    [theme.breakpoints.down('sm')]: {
        width: '100%',
        maxHeight: 'calc(100% - 98px)',
        position: 'absolute',
        height: 'auto',
        bottom: 0,
        padding: theme.spacing(4, 4, 8, 4),
        borderRadius: 0,
        borderTopLeftRadius: theme.spacing(8),
        borderTopRightRadius: theme.spacing(8),
    },
}));
export const Header = styled(Box)(({ theme }) => (Object.assign(Object.assign({ borderBottom: `1px solid ${theme.palette.grey200.main}`, paddingBottom: theme.spacing(4) }, theme.typography.subtitle1), { [theme.breakpoints.down('sm')]: Object.assign({}, theme.typography.subtitle2), '.MuiBox-root': {
        alignItems: 'flex-start',
    }, '.MuiIconButton-root': {
        marginTop: theme.spacing(0.75),
        '&:hover': {
            backgroundColor: 'transparent',
        },
        '&:first-child': {
            marginRight: theme.spacing(4),
        },
        '&:last-child': {
            marginLeft: theme.spacing(4),
        },
        '.MuiSvgIcon-root': {
            color: theme.palette.grey900.main,
        },
    } })));
export const Content = styled('div')(({ theme }) => (Object.assign({ overflow: 'auto' }, theme.typography.body1)));
export const Actions = styled(Box)(({ theme }) => ({
    paddingTop: theme.spacing(6),
    display: 'flex',
    justifyContent: 'end',
    marginTop: 'auto',
    [theme.breakpoints.down('sm')]: {
        '.MuiBox-root': {
            flexWrap: 'wrap',
            gap: 0,
            width: '100%',
        },
        '.MuiButton-root:nth-of-type(2)': {
            marginTop: theme.spacing(4),
        },
        '.MuiButton-root ~ .MuiButton-root': {
            marginLeft: 0,
        },
    },
}));
//# sourceMappingURL=styles.js.map